export default __webpack_public_path__ + "static/media/Brigand's Armguards of the Khan.f56cb257.jpg";